export enum TransactionStatus {
    Succeeded = 'Succeeded',
    Failed = 'Failed'
}